import CompletedConnected from './CompletedConnected'
export default CompletedConnected
